import { useEffect, useState } from 'react'

import { type Stop, type Shipment, isDrayage } from '../domain/Shipment'
import { ShipmentStopCheckedInOut } from './ShipmentStopCheckedInOut'
import { ShipmentStopInfo } from './ShipmentStopInfo'

type ShipmentStopProps = {
  stop: Stop
  stopState: {
    index: number
    checkIn?: string
    checkOut?: string
  }
  status: string
  lookupShipment: (uuid: string) => Promise<void>
  shipment: Shipment
}

export function ShipmentStop({
  stop,
  stopState,
  status,
  lookupShipment,
  shipment,
}: ShipmentStopProps) {
  const stopInfoState = stopState.checkIn || stopState.checkOut ? 'is-previous' : undefined

  const [state, setState] = useState<{
    index: number
    checkIn: string
    checkOut: string
  }>({
    index: 0,
    checkIn: '',
    checkOut: '',
  })

  useEffect(() => {
    setState({
      index: stop.stopIndex,
      checkIn: stopState.checkIn || '',
      checkOut: stopState.checkOut || '',
    })
  }, [stop.stopIndex, stopState.checkIn, stopState.checkOut])

  return (
    <div className="ls-PageShipmentsStatus-stop" data-testid="timeline-stop">
      <ShipmentStopInfo
        shipmentUUID={shipment.uuid}
        stop={stop}
        state={stopInfoState}
        status={status}
        lookupShipment={lookupShipment}
        isDrayageShipment={isDrayage(shipment)}
        shippingItems={shipment.items}
      />

      <ShipmentStopCheckedInOut
        type="in"
        stop={stop}
        stopState={state}
        lookupShipment={lookupShipment}
        shipmentUUID={shipment.uuid}
      />

      <ShipmentStopCheckedInOut
        type="out"
        stop={stop}
        stopState={state}
        lookupShipment={lookupShipment}
        shipmentUUID={shipment.uuid}
      />
    </div>
  )
}
